import getFcmService from "@/helpers/fcmService.js"
import { ref } from "vue"
import { useStore } from "vuex"

export default function useFcmToken() {
  const store = useStore()
  const token = ref(null)

  const getFcmToken = async () => {
    const fcmService = getFcmService()
    if (!fcmService) {
      throw new Error("FCM service is not available in this browser")
    }
    const fcmToken = await fcmService.requestPermissionAndGetToken()
    token.value = fcmToken
    return fcmToken
  }

  const initializeFcmToken = async (userId) => {
    await getFcmToken()
    await store.dispatch("authentication/sendFcmToken", {
      token: token.value,
      userId
    })
  }

  return {
    getFcmToken,
    initializeFcmToken
  }
}
